import config from "@/config";
import axios from "axios";
import store from "@/store";

export default {
	getUserPreferences() {
		return axios.get(`${config.PREFERENCES_URL}/user/preferences`, {
			  headers: {
				  "Authorization": store.getters.getAccessToken(),
				  "X-Org-Id": store.getters.getOrgID(),
            }
		});
	},
	save(preferences) {
		return axios.post(`${config.PREFERENCES_URL}/user/preferences`, preferences, {
			headers: {
				"Authorization": store.getters.getAccessToken(),
				"X-Org-Id": store.getters.getOrgID(),
			}
		});
	}
}